// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1DDCX","label":"LabeledBox_label__1Bhcs"};